import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("transition", {
    attrs: {
      name: "fade"
    }
  }, [_vm.loaded ? _c(VApp, [_c(VAppBar, {
    staticClass: "app-header",
    attrs: {
      height: "126px",
      "max-height": "126px",
      elevation: "0"
    }
  }, [_c("menu-component", {
    attrs: {
      logged: false
    }
  }), _c("div", {
    staticClass: "header-utils"
  }, [_c("router-link", {
    attrs: {
      to: {
        name: "login"
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var href = _ref.href,
          route = _ref.route,
          navigate = _ref.navigate;
        return [_c("img", {
          attrs: {
            src: require("@/assets/images/icon_profil_white.svg"),
            alt: ""
          },
          on: {
            click: navigate
          }
        })];
      }
    }], null, false, 3052357140)
  })], 1)], 1), _c(VMain, [_c(VContainer, {
    attrs: {
      fluid: ""
    }
  }, [_c("router-view")], 1)], 1), _c("footer-component", {
    attrs: {
      isTerms: false
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };